import lazyLoading from './lazyLoading'

export default {
  name: 'balance',
  path: '/dashboard',
  component: lazyLoading('balance/Balance'),
  meta: {
    default: true,
    title: 'menu.dashboard',
    iconClass: 'vuestic-icon vuestic-icon-extras',
    expanded: false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/balance.js